import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';

const BrandCard = ({ brand, variant = 'grid' }) => {
  if (variant === 'list') {
    return (
      <Link
        to={`/brands/${brand.id}`}
        className="group flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-emerald-300 hover:shadow-md"
      >
        <div className="flex h-20 w-32 shrink-0 items-center justify-center overflow-hidden rounded-md bg-slate-50 p-2">
          <img src={brand.logo} alt={`${brand.name} logo`} className="h-full w-full object-contain" loading="lazy" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-base font-semibold text-slate-900 group-hover:text-emerald-800">{brand.name}</h3>
          <Badge variant="secondary" className="mt-1 bg-emerald-50 text-emerald-800 hover:bg-emerald-50">
            {brand.category}
          </Badge>
        </div>
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link
        to={`/brands/${brand.id}`}
        className="group flex flex-col items-center gap-2 rounded-xl border border-slate-200 bg-white p-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-emerald-300 hover:shadow-md"
      >
        <div className="flex h-32 w-full items-center justify-center overflow-hidden rounded-md bg-slate-50 p-2">
          <img src={brand.logo} alt={`${brand.name} logo`} className="h-full w-full object-contain" loading="lazy" />
        </div>
        <p className="truncate text-center text-sm font-medium text-slate-800 group-hover:text-emerald-800">{brand.name}</p>
      </Link>
    );
  }

  return (
    <Link
      to={`/brands/${brand.id}`}
      className="group flex flex-col rounded-xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-emerald-300 hover:shadow-md"
    >
      <div className="flex h-52 items-center justify-center overflow-hidden rounded-md bg-slate-50 p-4">
        <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-110" loading="lazy" />
      </div>
      <div className="mt-5">
        <h3 className="text-lg font-semibold text-slate-900 group-hover:text-emerald-800">{brand.name}</h3>
        <Badge variant="secondary" className="mt-2 bg-emerald-50 text-emerald-800 hover:bg-emerald-50">
          {brand.category}
        </Badge>
      </div>
    </Link>
  );
};

export default BrandCard;
